import(/* webpackMode: "eager", webpackExports: ["TransitionLink"] */ "C:\\Users\\jimfa\\OneDrive\\Documents\\GitHub\\JDI-Website\\src\\components\\TransitionLink.tsx");
